import { configureStore } from '@reduxjs/toolkit'
import userReducres from '../features/User/userSlice'

export const store = configureStore({
  reducer: {
    user: userReducres,
  },
})